import _slicedToArray from "/opt/build/repo/web/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import * as React from 'react';
import { useIntersectionObserver } from './useIntersectionObserver';
/** Take a ref and return a piece of React state reflecting whether the referenced element is currently in the viewport or not  */

export function useInViewport(ref) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isInViewport = _React$useState2[0],
      setIsInViewport = _React$useState2[1];

  var onIntersect = React.useCallback(function (entries, observer) {
    var _a, _b;

    var isIntersecting = !!entries.find(function (entry) {
      return entry.isIntersecting;
    });

    if (isIntersecting && !isInViewport) {
      (_a = options.onEnter) === null || _a === void 0 ? void 0 : _a.call(options, entries);
      setIsInViewport(true);

      if (options.once) {
        observer.disconnect();
      }
    } else if (!isIntersecting && isInViewport) {
      (_b = options.onExit) === null || _b === void 0 ? void 0 : _b.call(options, entries);
      setIsInViewport(false);
    }
  }, [options.onEnter, options.onExit, options.once, isInViewport]);
  var intersectionObserverOptions = React.useMemo(function () {
    return {
      rootMargin: options.rootMargin,
      threshold: options.threshold
    };
  }, [options.rootMargin, options.threshold]);
  useIntersectionObserver(onIntersect, intersectionObserverOptions, ref);
  return isInViewport;
}